export default {
  init() {
    // Select the active navigation link in the pricing category tabs
    const activeNavLink = $("ul.nav.nav-tabs a.nav-link.active");

    // Check if there's an active navigation link
    if (activeNavLink.length > 0) {
      // Extract the active category ID from the href attribute of the active navigation link
      const activeCategoryId = activeNavLink
        .attr("href")
        .match(/pricing_category=(\d+)/)[1];

      // Call the function to update the pricing category parameter
      updatePricingCategoryParameter(activeCategoryId);
    }

    // Function to update the pricing category parameter in the URL
    function updatePricingCategoryParameter(newCategoryId) {
      // Parse the current URL to extract URL parameters
      let urlParams = new URLSearchParams(window.location.search);

      // Check if the URL already contains a pricing category parameter
      if (urlParams.has("pricing_category")) {
        // Get the current category ID from the URL
        const currentCategoryId = urlParams.get("pricing_category");

        // If the new category ID is different from the current one, update the URL parameter
        if (currentCategoryId !== newCategoryId) {
          urlParams.set("pricing_category", newCategoryId);
          var newUrl = window.location.pathname + "?" + urlParams.toString();
          history.pushState(null, null, newUrl);
        }
      } else {
        // If there's no pricing category parameter in the URL, append it
        urlParams.append("pricing_category", newCategoryId);
        var newUrl = window.location.pathname + "?" + urlParams.toString();
        history.pushState(null, null, newUrl);
      }
    }

    // Select the table index input field
    const tableIndex = $('input[name="table_index"');

    // Check if the table index input field exists
    if (tableIndex.length > 0) {
      // Get the value of the table index input field
      const tableIndexVal = tableIndex.val();

      // Call the function to update the pricing ID parameter
      updatePricingIdParameter(tableIndexVal);
    }

    // Function to update the pricing ID parameter in the URL
    function updatePricingIdParameter(tableIndexVal) {
      // Parse the current URL to extract URL parameters
      let urlParams = new URLSearchParams(window.location.search);

      // Check if the URL already contains a pricing ID parameter
      if (urlParams.has("pricing_id")) {
        // Get the current pricing ID from the URL
        const currentPricingId = urlParams.get("pricing_id");

        // If the new pricing ID is different from the current one and not equal to 0, update the URL parameter
        if (currentPricingId !== tableIndexVal && tableIndexVal != 0) {
          urlParams.set("pricing_id", tableIndexVal);
          var newUrl = window.location.pathname + "?" + urlParams.toString();
          history.pushState(null, null, newUrl);
        }
      } else {
        // If there's no pricing ID parameter in the URL, append it
        urlParams.append("pricing_id", tableIndexVal);
        var newUrl = window.location.pathname + "?" + urlParams.toString();
        history.pushState(null, null, newUrl);
      }
    }
  },
  finalize() {
    // Prevent default behavior when clicking on an element with data-target="#modalDeletePricing"
    $('[data-target="#modalDeletePricing"]').on("click", function (e) {
      e.preventDefault();
    });

    // Event handler for deleting a column
    $("body").on("click", ".delete-column", function (e) {
      e.preventDefault();
      // Find the index of the column to be deleted
      var columnIndex = $(this).closest("th").index();
      // Remove the corresponding cells (both th and td) from each row in the pricing table
      $("#pricing-table tr").each(function () {
        $(this)
          .find("td:eq(" + columnIndex + "), th:eq(" + columnIndex + ")")
          .remove();
      });
      // Reindex the remaining columns
      reindexRows();
    });

    // Event handler for deleting a row
    $("body").on("click", ".delete-row", function (e) {
      e.preventDefault();
      // Remove the closest row when clicking on an element with the class "delete-row"
      $(this).closest("tr").remove();
      // Reindex the remaining rows
      reindexRows();
    });

    // Event handler for deleting cells
    $("#deleteCells").on("click", function (e) {
      e.preventDefault();
      // Delete rows where the checkbox for rows is checked
      $(".checkbox.checkbox-row:checked").each(function () {
        var row = $(this).closest("tr");
        row.remove();
      });
      // Delete columns where the checkbox for columns is checked
      $(".checkbox.checkbox-column:checked").each(function () {
        var columnIndex = $(this).closest("th").index();
        $("#pricing-table tr").each(function () {
          $(this)
            .find("td:eq(" + columnIndex + "), th:eq(" + columnIndex + ")")
            .remove();
        });
      });
      // Reindex the rows after deletion
      reindexRows();
    });

    // Function to reindex rows in the pricing table
    function reindexRows() {
      // Reindex header row (thead)
      $("#pricing-table thead tr").each(function (rowIndex) {
        $(this)
          .find("th")
          .each(function (colIndex) {
            // Find input elements of type text
            var input = $(this).find("input[type='text']");
            if (input.length > 0) {
              // Update the name attribute of the input element
              let newName = "data[thead][" + (colIndex - 3) + "]";
              input.attr("name", newName);
            }
          });
      });

      // Reindex body rows (tbody)
      $("#pricing-table tbody tr").each(function (rowIndex) {
        $(this)
          .find("td")
          .each(function (colIndex) {
            // Find input elements of type text or select
            var input = $(this).find("input[type='text'], select");
            if (input.length > 0) {
              // Update the name attribute of the input element
              let newName =
                "data[tbody][" + rowIndex + "][" + (colIndex - 1) + "]";
              input.attr("name", newName);
            }
          });
      });
    }

    // Event handler for validating product selection
    $("#validateProduct").on("click", function (e) {
      e.preventDefault();
      // Get the selected product value from the outside dropdown
      var selectedProduct = $("#productList").val();

      // Iterate through the checked checkboxes in the table
      $(".checkbox:checked").each(function () {
        // Set the selected product value to the corresponding table dropdown
        $(this).closest("tr").find(".productSelect").val(selectedProduct);
      });

      // Uncheck all checkboxes and reset the product list to its default value
      $(".checkbox").prop("checked", false);
      $("#productList").val($("#productList option:first").val());
    });

    // Event handler for merging selected columns
    $("#mergeColumns").on("click", function (e) {
      e.preventDefault();
      // Call the function to merge selected columns
      mergeSelectedColumns();
    });

    // Function to merge selected columns in the pricing table
    function mergeSelectedColumns() {
      // Get selected columns
      var selectedColumns = $(".checkbox.checkbox-column:checked");

      // Ensure exactly 2 columns are selected
      if (selectedColumns.length === 2) {
        // Get indices of the selected columns
        var columnIndex1 = selectedColumns.eq(0).closest("th").index();
        var columnIndex2 = selectedColumns.eq(1).closest("th").index();

        // Iterate through each row in the table
        $("#pricing-table tr").each(function () {
          var row = $(this);
          // Get the cells in the selected columns for the current row
          var cell1 = row.find(
            "td:eq(" + columnIndex1 + "), th:eq(" + columnIndex1 + ")"
          );
          var cell2 = row.find(
            "td:eq(" + columnIndex2 + "), th:eq(" + columnIndex2 + ")"
          );

          // Get input elements in the cells
          var cell1Input = cell1.find("input");
          var cell2Input = cell2.find("input");

          // Concatenate values of the input elements in the selected cells
          cell1Input.val(cell1Input.val() + " " + cell2Input.val());
          // Remove the second cell
          cell2.remove();
        });

        // Uncheck all checkbox columns
        $(".checkbox-column").prop("checked", false);

        // Reindex the rows
        reindexRows();
      } else {
        // Alert user if exactly 2 columns are not selected
        alert("Please select exactly 2 columns.");
      }
    }

    // Close alert message after 3 seconds
    setTimeout(function () {
      $("#alert-message").alert("close");
    }, 3000);

    // Event handler for adding a new row to the table
    $("body").on("click", ".add-line-row", function (e) {
      e.preventDefault();

      // Create a new row
      var newRow = $("<tr></tr>");
      // Get the index of the clicked row
      var index = $(this).closest("tr").index();
      // Get the number of columns in the table header
      var columnCount = $("#pricing-table thead th").length;
      // Get product values from the external source
      var products = $("#listing-products-js").data("values");
      // Create a select element for products
      var select = $("<select>", { name: "", class: "productSelect" });
      // Add default option to the select element
      select.append('<option value="none">Produit</option>');

      // Add each product option to the select element
      $.each(products, function (index, value) {
        select.append('<option value="' + value + '">' + value + "</option>");
      });

      // Loop through each column
      for (var i = 0; i < columnCount; i++) {
        if (i == 0) {
          // Add a button and checkbox for the first column
          newRow.append(`
        <td>
        <button class="add-line add-line-row">+</button>
        <div class="d-flex align-items-center">
          <input type="checkbox" name="" id="" class="checkbox checkbox-row">
          <div class="ml-auto d-flex">
            <button class="delete-row button button-outline-danger mr-2">
              <i class="fa-solid fa-trash"></i>
            </button>
            <button class="move-h-row top-row button mr-2">
              <i class="fa-regular fa-circle-caret-up"></i>
            </button>
            <button class="move-h-row bottom-row button">
              <i class="fa-regular fa-circle-caret-down"></i>
            </button>
          </div>
        </div>
      </td>`);
        } else if (i == 1) {
          // Add a select element for the second column
          newRow.append(
            '<td><select name=""><option value="default">Default</option><option value="main-title">Main title</option><option value="table-title">Table title</option><option value="sub-title">Sub title</option><option value="legend">Legend</option><option value="link">Link</option></select></td>'
          );
        } else if (i == 2) {
          // Add the product select element for the third column
          newRow.append("<td>" + select.prop("outerHTML") + "</td>");
        } else {
          // Add an input field for other columns
          newRow.append('<td><input class="w-100" type="text" name></td>');
        }
      }

      // Insert the new row after the clicked row
      $(newRow).insertAfter($("#pricing-table tbody tr:eq(" + index + ")"));
      // Reindex the rows
      reindexRows();
    });

    // Event handler for moving a row to the top
    $(document).on("click", ".top-row", function (e) {
      e.preventDefault();
      var currentRow = $(this).closest("tr"); // Get the current row
      var previousRow = currentRow.prev("tr"); // Get the previous row

      // Move the current row above the previous row
      if (previousRow.length > 0) {
        currentRow.insertBefore(previousRow);
      }
      // Reindex the rows
      reindexRows();
    });

    // Event handler for moving a row to the bottom
    $(document).on("click", ".bottom-row", function (e) {
      e.preventDefault();
      var currentRow = $(this).closest("tr"); // Get the current row
      var nextRow = currentRow.next("tr"); // Get the next row

      // Move the current row below the next row
      if (nextRow.length > 0) {
        currentRow.insertAfter(nextRow);
      }
      // Reindex the rows
      reindexRows();
    });

    // Event handler for moving a column to the left
    $(document).on("click", ".left-column", function (e) {
      e.preventDefault();
      var $th = $(this).closest("th");
      var index = $th.index();

      // Check if the column index is greater than or equal to 4 (starting from index 3)
      if (index >= 4) {
        // Get the previous column
        var $prevTh = $th.prev("th");

        // Move the current column before the previous column
        if ($prevTh.length > 0) {
          $th.insertBefore($prevTh);

          // Move corresponding cells in the tbody
          moveColumn(index, index - 1);
        }
      }
    });

    // Event handler for moving a column to the right
    $(document).on("click", ".right-column", function (e) {
      e.preventDefault();
      var $th = $(this).closest("th");
      var index = $th.index();
      var lastColumnIndex = $th.closest("thead").find("th").length - 1;

      // Check if the column index is less than the index of the last column
      if (index < lastColumnIndex) {
        // Get the next column
        var $nextTh = $th.next("th");

        // Move the current column after the next column
        if ($nextTh.length > 0) {
          $th.insertAfter($nextTh);

          // Move corresponding cells in the tbody
          moveColumn(index, index + 1);
        }
      }
    });

    // Function to move cells in the tbody when moving columns
    function moveColumn(fromIndex, toIndex) {
      $("tbody tr").each(function () {
        var $currentTd = $(this).children("td").eq(fromIndex);
        var $targetTd = $(this).children("td").eq(toIndex);

        // Move the current cell to the right or left based on the indices
        if (fromIndex < toIndex) {
          $currentTd.insertAfter($targetTd);
        } else {
          $currentTd.insertBefore($targetTd);
        }
      });
    }

    // Event handler for adding a new column
    $("body").on("click", ".add-line-column", function (e) {
      e.preventDefault();

      var index = $(this).closest("th").index();
      // Insert a new column after the clicked column
      $("#pricing-table thead th").eq(index).after(`
    <th>
        <button class="add-line add-line-column">+</button>
        <div class="d-flex align-items-center">
            <input type="checkbox" name="" id="" class="checkbox checkbox-column mr-3">
            <div class="ml-auto d-flex">
              <button class="delete-column button button-outline-danger mr-3">
                <i class="fa-solid fa-trash"></i>
              </button>
              <button class="move-h-column left-column button mr-1">
                <i class="fa-regular fa-circle-caret-left"></i>
              </button>
              <button class="move-h-column right-column button">
                <i class="fa-regular fa-circle-caret-right"></i>
              </button>
            </div>
          </div>
      </th>`);

      // Insert corresponding cells in the tbody
      $("#pricing-table tbody tr").each(function () {
        $(this)
          .find("td")
          .eq(index)
          .after('<td><input class="w-100" type="text" name></td>');
      });
      // Reindex the rows
      reindexRows();
    });

    $("#contentGenerator, #buttonGenerator").click(function (e) {
      e.preventDefault();
    });

    $("#generateHtmlButton").on("click", function () {
      var url = $("#button_URL").val();
      var name = $("#button_name").val();
      var htmlCode =
        '<a href="' + url + '" class="btn btn-outline">' + name + "</a>";
      $("#button_html_preview").val(htmlCode);
      $("#copyHtmlButton").removeAttr("disabled");
    });

    $("#copyHtmlButton").on("click", function () {
      var copyText = $("#button_html_preview").val();
      navigator.clipboard
        .writeText(copyText)
        .then(function () {
          alert("Copied the HTML code: " + copyText);
          $("#modalButtonGenerator").modal("hide");
        })
        .catch(function (error) {
          console.error("Unable to copy: ", error);
        });
    });

    $("#modalButtonGenerator").on("hidden.bs.modal", function () {
      $("#button_URL, #button_name, #button_html_preview").val("");
      $("#copyHtmlButton").attr("disabled");
    });

    // wp.editor.remove("content_html_preview");
    wp.editor.initialize("content_html_preview", {
      tinymce: {
        toolbar1: "bold italic underline strikethrough | link unlink",
        height: 200,
        forced_root_block: false,
      },
      mediaButtons: false,
    });

    $("#copyHtmlContent").on("click", function () {
      var copyText = tinymce.activeEditor.getContent();
      navigator.clipboard
        .writeText(copyText)
        .then(function () {
          alert("Copied the HTML code: " + copyText);
          $("#modalContentGenerator").modal("hide");
        })
        .catch(function (error) {
          console.error("Unable to copy: ", error);
        });
    });
  },
};
